import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { round_edit_cycle, round_sel_cycle_group } from 'api/Attendance';
export default {
  data: function data() {
    return {
      visible: false,
      // 组件展示
      form: {
        id: '',
        // 考勤组ID
        num: 2,
        // 当前周期天数
        shift_ids: [],
        // 班次
        cycle_id: '',
        // 周期iD
        group_ids: [] // 选中的周期分组序号（1-31
      },

      tableData: [],
      // 表格数据
      scheduling: [],
      // 班次选项
      active: 0,
      // step
      loading: false
    };
  },
  methods: {
    init: function init(params, data, setting) {
      this.active = 0;
      this.visible = true;
      // 下啦选项循环
      this.scheduling = params || [];
      this.form.id = setting.groupId;
      this.form.cycle_id = setting.cycleId;
      // data存在则数据回显
      if (data) {
        this.form.num = data.length;
        this.form.shift_ids = data.map(function (item) {
          return item.id;
        });
      }
    },
    // 删除多余的选项
    handleChange: function handleChange() {
      var _this = this;
      this.$nextTick(function () {
        return _this.form.shift_ids.splice(_this.form.num);
      });
    },
    handlerSelection: function handlerSelection(arr) {
      this.form.group_ids = arr.map(function (item) {
        return item.group_id;
      });
    },
    confirm: function confirm() {
      var _this2 = this;
      this.loading = true;
      // active 0 下一步 1保存
      if (!this.active) {
        return round_edit_cycle(this.form).then(function (res) {
          _this2.active = 1;
          _this2.tableData = res.data;
          _this2.form.cycle_id = res.data[0].cycle_id;
        }).finally(function () {
          return _this2.loading = false;
        });
      }
      round_sel_cycle_group(this.form).then(function () {
        _this2.visible = false;
        _this2.$emit('update');
        _this2.loading = false;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }
};